/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerUpdateMutationRequest, TemplateSectionsControllerUpdateMutationResponse, TemplateSectionsControllerUpdatePathParams, TemplateSectionsControllerUpdate400, TemplateSectionsControllerUpdate401, TemplateSectionsControllerUpdate403, TemplateSectionsControllerUpdate404 } from "../../models/checklistsController/TemplateSectionsControllerUpdate";

function getTemplateSectionsControllerUpdateUrl(id: TemplateSectionsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-template-sections/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist template section
 * {@link /api/v1/checklist-template-sections/:id}
 */
export async function templateSectionsControllerUpdate(id: TemplateSectionsControllerUpdatePathParams["id"], data?: TemplateSectionsControllerUpdateMutationRequest, config: Partial<RequestConfig<TemplateSectionsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateSectionsControllerUpdateMutationResponse, ResponseErrorConfig<TemplateSectionsControllerUpdate400 | TemplateSectionsControllerUpdate401 | TemplateSectionsControllerUpdate403 | TemplateSectionsControllerUpdate404>, TemplateSectionsControllerUpdateMutationRequest>({ method : "PATCH", url : getTemplateSectionsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}